import { render, staticRenderFns } from "./WordReplacements.vue?vue&type=template&id=002d0d1c"
import script from "./WordReplacements.vue?vue&type=script&lang=js"
export * from "./WordReplacements.vue?vue&type=script&lang=js"
import style0 from "./WordReplacements.vue?vue&type=style&index=0&id=002d0d1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports